import React, { useContext } from "react";
import { SettingsContext } from "../providers/SettingsProvider";
import Footer from "./Footer";
import "../css/generalSettingsPage.scss";
import { Switch } from "@mui/material";

// A small, growable list of AI-powered features, each with its own on/off switch.
// Currently just thread-matching, but built as a list so more can be added later
// without restructuring the page.
const AIFeaturesSettings = () => {
  const { aiThreadMatchingEnabled, toggleAiThreadMatching } = useContext(SettingsContext);

  return (
    <div className="generalSettingsPage">
      <Footer title={"AI Features"} back={true} />

      <div className="settingsOptionsContainer">
        <div className="formLine">
          <label htmlFor="aiThreadMatching">Thread matching (quote/invoice drafts)</label>
          <Switch
            checked={aiThreadMatchingEnabled}
            onChange={() => toggleAiThreadMatching(aiThreadMatchingEnabled)}
          />
        </div>
      </div>
    </div>
  );
};

export default AIFeaturesSettings;
